module.exports = __webpack_public_path__ + "static/img/flow1.2a3f083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/合成技术整体解决方案/flow1.jpg
// module id = bcsn
// module chunks = 16